/** Grid or strip heatmap — opacity scales with value */
export default function Heatmap({
  cells = [],
  columns = [],
  className = "",
  emptyLabel = "No data",
}) {
  if (!cells.length) {
    return <div className={`heatmap heatmap--empty ${className}`}>{emptyLabel}</div>;
  }

  const max = Math.max(1, ...cells.map((c) => Number(c.value) || 0));

  if (columns.length > 0) {
    const rowLabels = [...new Set(cells.map((c) => c.row))];
    return (
      <div
        className={`heatmap heatmap--grid ${className}`}
        style={{ gridTemplateColumns: `minmax(80px, 1fr) repeat(${columns.length}, minmax(48px, 1fr))` }}
      >
        <div className="heatmap-corner" />
        {columns.map((col) => (
          <div key={`h-${col}`} className="heatmap-col-head">
            {col}
          </div>
        ))}
        {rowLabels.map((row) => [
          <div key={`${row}-label`} className="heatmap-row-head">
            {row}
          </div>,
          ...columns.map((col) => {
            const cell = cells.find((c) => c.row === row && c.col === col);
            const v = Number(cell?.value) || 0;
            const intensity = v / max;
            return (
              <div
                key={`${row}-${col}`}
                className="heatmap-cell"
                style={{ "--heat": intensity }}
                title={`${row} · ${col}: ${v}`}
              >
                {v > 0 ? v : ""}
              </div>
            );
          }),
        ])}
      </div>
    );
  }

  return (
    <div className={`heatmap heatmap--strip ${className}`}>
      {cells.map((c) => {
        const v = Number(c.value) || 0;
        const intensity = v / max;
        return (
          <div
            key={c.label || c.row}
            className="heatmap-strip-cell"
            style={{ "--heat": intensity }}
            title={`${c.label || c.row}: ${v}`}
          >
            <span className="heatmap-strip-label">{c.label || c.row}</span>
            <span className="heatmap-strip-value">{v}</span>
          </div>
        );
      })}
    </div>
  );
}
